module.exports = __webpack_public_path__ + "static/Architecture-eBook-Cover-242x300-bb41584ee693b2ba757c413857f2422b.png";